<template>
  <div
    v-if="data"
    :class="{
      'relative pb-40 pt-200px text-center text-www-color-white md:pb-64 md:pt-40': true,
    }"
  >
    <BackgroundImage
      :background="data.heroImage"
      :preload="true"
      :_type="'imageBackground'"
      background-size="full-page"
      light-text
      :class="{
        'absolute top-0 -z-10 min-h-full w-full md:inset-0': true,
      }"
    ></BackgroundImage>

    <div
      :class="{
        'container mx-auto': true,
      }"
    >
      <h1
        :class="{
          'text-28px font-black leading-8 lg:text-6xl lg:leading-69px': true,
        }"
      >
        {{ data.title }}
      </h1>

      <h2
        :class="{
          'mt-4 text-2xl font-bold leading-7': true,
        }"
      >
        {{ data.subtitle }}
      </h2>

      <div class="mb-10 mt-30px flex justify-center">
        <Button
          v-if="data.CTAButton"
          :button-props="data.CTAButton"
          :class="{
            'w-full md:w-fit lg:w-auto': true,
          }"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BackgroundImage from '~/components/Atmos/BackgroundImage/BackgroundImage.vue';
import Button from '~/components/Atmos/Button/Button.vue';
import type { QueryPlatformResult } from '~/sanity/types';

interface Props {
  data: QueryPlatformResult;
}

defineProps<Props>();
</script>
